import { render, staticRenderFns } from "./activityLogs.vue?vue&type=template&id=095202ba&"
import script from "./activityLogs.vue?vue&type=script&lang=js&"
export * from "./activityLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports